<body class="home-page01 container-fluid p26">

  <div class="container-fluid">
    <div class="ups-component hero has-breadcrumbs">
      <nav aria-label="breadcrumb" class="bread_cus">
        <ol class="breadcrumb">
          <li class="breadcrumb-item active" aria-current="page">Business Services
          </li>
        </ol>
      </nav>
      <div class="ups-container">
        <div class="card ups-card">
          <div class="card-img fade-in-up-light"><img src="../../../../assets/redesignImages/BusinessServicesImg.png"
              alt="Male looking at a paper and working on a laptop in a warehouse"
              title="Male looking at a paper and working on a laptop in a warehouse" class="img-fluid" loading="lazy">
          </div>
          <div class="card-body fade-in-up-light">
            <div class="card-body-content">
              <h1 class="maj-head0">Business Services</h1>
              <p class="maj-sub0">Access solutions to keep your cash flowing and goods moving.</p>
              <a href="/about/contact-us/
" rel="noopener">
                <button class="business-services__inner-div--button">
                  Contact Us
                  <img class="blue-tag" src="../../../../assets/redesignImages/button-menu.png">
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
      <img class="bus-curved-image" alt="Business-services-img" src="../../../../assets/redesignImages/Vector.png">
      <!-- <div class="arc-container">
  <svg xmlns="" width="1440" class="arc" height="72" viewBox="0 0 1440 72" fill="none" aria-hidden="true"
      focusable="false">
      <path d="M-400 176C139.222 -24.794 1028.42 -10.941 1440 13.8751V176L-400 176Z" fill="white"></path>
  </svg>
</div> -->
    </div>
    <!-- <div class="arc-container"> -->

    <!-- </div> -->


    <!-- Stay Ahead with Services container -->

    <div class="text-center align-par01" style="    margin-top: 48px;">
      <p class="inn-par0">
        Stay Ahead with Services Designed to Assist with Growth, Payments and Imports
      </p>
    </div>

    <!-- <hr class="featured-resources__hr"> -->


    <!-- Continuous Customs Bonds Container -->
    <div class="card-bus card-container">

      <div class="card fl0">

        <div class="card-header BsHead">
          <h2 class="sub-title">Continuous Customs Bonds</h2>
        </div>
        <div class="card-img BsImage ">
          <img alt="Cargo ship in water at loading dock during sunset" class="img-fluid"
            src="../../../../assets/redesignImages/ContinuousCustomsBondsImg.png" />

        </div>
        <div class="card-body BsBody crB02">
          <div class="card-body-content">
            <p class="sub-cont0"> One bond covers your imports and speeds customs clearance for a whole
              year.</p>

            <div class="hero-panel-button home-btn01">
              <a href="/business-services/continuous-customs-bonds/" class="get-secret-btn home-btn02" tabindex="-1"
                rel="noopener">Learn
                More <img class="btn-mn0" src="../../../../assets/redesignImages/button-menu.png"></a>
            </div>

          </div>
        </div>
      </div>

    </div>





    <!-- Payment Services Container -->
    <div class="card-container">

      <div class="card fl0">

        <div class="card-header crHead">
          <h2 class="sub-title">Payment Services</h2>
        </div>
        <div class="card-img imgbn0">
          <img alt="Female and male on a forklift looking at a clipboard in a warehouse" class="img-fluid"
            src="../../../../assets/redesignImages/PaymentServicesImg.png" />

        </div>
        <div class="card-body crB01">
          <div class="card-body-content">
            <p class="sub-cont0"> Get secure, affordable payment solutions for today’s fast-moving
              market.</p>

            <div class="hero-panel-button home-btn01 ">
              <a href="/business-services/payment-services/" class="get-secret-btn home-btn02" style="width: 158px;"
                tabindex="-1" rel="noopener">Get Started <img class="btn-mn0 "
                  src="../../../../assets/redesignImages/button-menu.png"></a>
            </div>

          </div>
        </div>
      </div>

    </div>







    <!-- Featured Resources container -->


    <h2 class="featured-resources__inner-container">
      Featured Resources
    </h2>
    <!-- <hr class="featured-resources__hr"> -->
    <p class="featured-resources__inner-second-container">
      From insurance services to payment solutions, we’ve got stories and insights that won’t put you to
      sleep.
    </p>
    <div class="three-container">
      <div class="row">
        <div class="col-md-4 res-4">
          <div class="featured-resource-card">
            <img class="featured-resource-card-image" alt="featured-resources-1-img"
              src="../../../../assets/redesignImages/Featured-resources-1.png"><br>
            <hr class="featured-resource-card-hr">
            <p class="featured-resource-card-heading">
              INSIGHTS
            </p>
            <p class="featured-resource-card-main-content">Streamline Your Imports</p>
            <p class="featured-resource-card-sub-content" Read more on what consumers are looking for.>
              Coverage for all your entries for the year.</p>
            <a class="featured-resource-card-a-tag" href="/resources/streamline-your-imports/" rel="noopener">Get
              Details <img class="blue-tag" src="../../../../assets/redesignImages/blueButton.png"></a>
          </div>
        </div>
        <div class="col-md-4 res-4">
          <div class="featured-resource-card">
            <img class="featured-resource-card-image" alt="featured-resources-1-img"
              src="../../../../assets/redesignImages/Feature-resources-2.png"><br>
            <hr class="featured-resource-card-hr">
            <p class="featured-resource-card-heading">
              INSIGHTS
            </p>
            <p class="featured-resource-card-main-content">Supply Chain Resiliency</p>
            <p class="featured-resource-card-sub-content">Tips to keep your business running smoothly.
            </p>
            <a class="featured-resource-card-a-tag" href="/resources/5-ways-to-maximize-supply-chain-resiliency/"
              rel="noopener">Get
              Tips<img class="blue-tag" src="../../../../assets/redesignImages/blueButton.png"></a>
          </div>
        </div>
        <div class="col-md-4 res-4">
          <div class="featured-resource-card">
            <img class="featured-resource-card-image" alt="featured-resources-1-img"
              src="../../../../assets/redesignImages/Feature-resources-3.png"><br>
            <hr class="featured-resource-card-hr">
            <p class="featured-resource-card-heading">
              INSIGHTS
            </p>
            <p class="featured-resource-card-main-content">Emerging Supply Chain Risks</p>
            <p class="featured-resource-card-sub-content">Tips to secure your supply chain.</p>
            <a class="featured-resource-card-a-tag" href="/resources/emerging-supply-chain-risks/" rel="noopener">Learn
              More<img class="blue-tag" src="../../../../assets/redesignImages/blueButton.png"></a>
          </div>
        </div>
      </div>
    </div>
    <div style="display: contents;" class="col-sm-12">
      <div class="card" id="white-contact-card">
        <div class="card-body white-card-content">
          <h5 class=" card-title white-bann-title">Ask an Expert</h5>
          <p class="card-text  white-bann-para"> Questions? We’ll connect you to the people with the
            answers.
          </p>

          <div class="hero-panel-button white-card-btn">
            <a href="/about/contact-us/" class="get-secret-btn get-white-btn" tabindex="-1" style="width: 147px;"
              rel="noopener">Contact Us<img class="btn-mn0" src="../../../../assets/redesignImages/button-menu.png"></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</body>